var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 249,
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 249,
    height: 249,
    rx: 50,
    fill: "#40B0BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199 87.5C197.18 80.77 191.93 75.5 185.2 73.7C176.16 70.21 88.6 68.5 63.2 73.8C56.47 75.62 51.2 80.87 49.4 87.6C45.32 105.5 45.01 144.2 49.5 162.5C51.32 169.23 56.57 174.5 63.3 176.3C81.2 180.42 166.3 181 185.3 176.3C192.03 174.48 197.3 169.23 199.1 162.5C203.45 143 203.76 106.7 199 87.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 125L109.2 101.6V148.4L150 125Z",
    fill: "#40B0BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.03f307c471d1a31e999c272297c68ff9.svg";
export { ForwardRef as ReactComponent };